<template>
  <div>
    <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading2">
      <div id="admin-loader-text">Deleting</div>
      <div id="admin-loader"></div>
    </div>

    <div class="" v-if="changed">
      <b-container class="col-lg-10 mt-5">
        <h3 class="text-info text-center pt-4 my-4">Cash Flow History</h3>
        <!-- User Interface controls -->
        <el-card
          shadow="always"
          style="background-color: #f5f7fa; overflow: initial"
        >
          <b-row>
            <!-- <b-col sm="4" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-form-datepicker
                  placeholder="Start Date"
                  id="start-datepicker"
                  v-model="startDate"
                  class="mb-2"
                  :isRTL="true"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                ></b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col sm="4" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-form-datepicker
                  placeholder="End Date"
                  id="end-datepicker"
                  v-model="endDate"
                  class="mb-2"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                ></b-form-datepicker>
              </b-form-group>
            </b-col> -->
            <b-col sm="3" class="my-1">
              <b-form-group label="" class="mb-0">
                <el-date-picker
                  size="medium"
                  v-model="month"
                  :picker-options="{
                    disabledDate: (time) => disabledDate(time),
                  }"
                  type="month"
                  placeholder="Month"
                >
                </el-date-picker>
              </b-form-group>
            </b-col>
            <b-col sm="3" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-form-select
                  placeholder="Store Location"
                  v-model="storeLocation"
                  :options="stores"
                ></b-form-select>
              </b-form-group>
            </b-col>

            <b-col sm="3" class="my-1">
              <b-form-group label="" class="mb-0">
                <el-button
                  style="display: block; margin: 0 auto"
                  type="primary"
                  size="medium"
                  @click="searchCashFlows"
                  >Search</el-button
                >
              </b-form-group>
            </b-col>

            <b-col sm="3" class="my-1" v-if="!currentCashFlow">
              <b-form-group label="" class="mb-0">
                <el-button
                  style="display: block; margin: 0 auto"
                  type="primary"
                  size="medium"
                  @click="
                    $router.push({
                      name: 'cash-flow',
                      query: { create: 'true' },
                    })
                  "
                  >Open Cash Flow</el-button
                >
              </b-form-group>
            </b-col>

            <b-col sm="3" class="my-1" v-if="currentCashFlow">
              <b-form-group label="" class="mb-0">
                <el-button
                  style="display: block; margin: 0 auto"
                  type="primary"
                  size="medium"
                  @click="
                    $router.push({
                      name: 'cash-flow',
                      query: { update: 'true', id: currentCashFlow.id },
                    })
                  "
                  >Update/Close Cash Flow</el-button
                >
              </b-form-group>
            </b-col>

            <!-- <b-col sm="3" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-form-select
                  v-model="cashier"
                  :options="options2"
                ></b-form-select>
              </b-form-group>
            </b-col> -->
          </b-row>
        </el-card>

        <!-- Main table element -->
        <el-card id="realtable" style="overflow-x: scroll;" shadow="always">
          <TableHeader :pageOptions="pageOptions" :fields="fields" :items="items" :perPage="perPage" :month="month" 
          :visibleFields="undefined" :downloadCSVMethod="'downloadCSVCashFlow'" />
          <b-table
            show-empty
            stacked="sm"
            :items="items"
            :fields="fields"
            :hover="true"
            head-variant="dark"
            :current-page="currentPage"
            :per-page="perPage"
            :empty-text="emptyText"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            @filtered="onFiltered"
            class="mt-4"
          >
            <template slot="index" slot-scope="data">
              {{ data.index + 1 }}
            </template>

            <template slot="actions" slot-scope="row">
              <div class="btn-group" role="group" aria-label="Basic example">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->

                <a
                  size="sm"
                  @click.stop="row.toggleDetails"
                  class="btn btn-sm btn-info text-white"
                >
                  View
                </a>
                <!-- <a
                  size="sm"
                  @click="open(row.item.id)"
                  class="btn btn-sm btn-danger text-white"
                >
                  Delete
                </a> -->
              </div>
            </template>
          </b-table>
        </el-card>
        <b-col md="3" class="my-1">
          <b-form-group label="" class="mb-0">
            <b-form-select v-model="perPage">
              <option disabled>per page</option>
              <option :value="10">10</option>
              <option :value="20">20</option>
              <option :value="40">40</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
        <!-- Info modal -->
        <!-- <b-modal id="modalInfo" @hide="resetModal" :title="modalInfo.title" ok-only>
      <pre>{{ modalInfo.content }}</pre>
       <AddProduct/>
    </b-modal> -->
      </b-container>
    </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
import TableHeader from "./TableHeader.vue";

const items = [];
export default {
  name: "cashFlowlist",
  components: { TableHeader},
  data() {
    return {
      emptyText: "Loading Records...",
      items: [],
      fields: [
        "index",
        //  { key: 'id', label: 'Order id', sortable: true },
        { key: "start", label: "Start Date", sortable: true },
        { key: "end", label: "End Date", sortable: true },
        { key: "open", label: "Open Amount", sortable: true },
        { key: "close", label: "Close Amount", sortable: true },
        { key: "sales", label: "Sales", sortable: true },
        { key: "add", label: "Additions", sortable: true },
        { key: "deduct", label: "Deductions", sortable: true },
        { key: "diff", label: "Difference", sortable: true },
        { key: "createdBy", label: "Created By", sortable: true },
        { key: "updatedBy", label: "Updated By", sortable: true },
        { key: "updated", label: "Updated", sortable: true },
        // { key: "actions", label: "Actions" },
      ],

      stores: this.$store.state.stores,
      storeLocation: this.$store.state.selectedStore,
      month: new Date(),
      currentCashFlow: undefined,
      invoiceNo: "",
      customer: "",
      cashier: null,
      productId: "",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: ["Per Page", 5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      isLoggedIn: false,
      currentUser: false,
      modalInfo: { title: "", content: "" },
      loading: false,
      loading1: false,
      loading2: false,
      changed: false,
      shops: [],
      orders: "",
    };
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    disabledDate(date) {
      return date > new Date();
    },
    searchCashFlows() {
      console.log("month", this.month);
      if (this.month === "") {
        return alert("Please select month");
      }
      if (!this.storeLocation) {
        return alert("Please select store location");
      }
      this.loading = true;
      this.changed = false;
      this.items = [];
      this.getCashFlows(this.month, this.storeLocation);
    },
    getCashFlows(dateToGetRecord, storeToGet) {
      const store = storeToGet ? storeToGet : this.$store.state.selectedStore;
      const date = dateToGetRecord ? new Date(dateToGetRecord) : new Date();
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
      console.log("store", store, date, firstDay, lastDay);
      this.$store.state.secondaryDatabase
        .collection("cashflow")
        .where("start", ">=", firebase.firestore.Timestamp.fromDate(firstDay))
        .where("start", "<=", firebase.firestore.Timestamp.fromDate(lastDay))
        .where("store", "==", store)
        .orderBy("start", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            if (!doc.data().end) {
              data.diff = 'Not closed yet'
            }
            data.id = doc.id;
            data.start = doc.data().start.toDate().toLocaleDateString();
            data.updated = doc.data().updated
              ? doc.data().updated.toDate().toLocaleString()
              : "";
            if (data.end) {
              data.end = doc.data().end.toDate().toLocaleDateString();
            }
            this.items.push(data);
            this.currentCashFlow = this.items.find((item) => !item.end);
            this.totalRows = this.items.length;
            // this.$store.state.expenses = this.items;
          });
          if (this.items.length == 0) {
            this.emptyText = "There are no records to show";
          }
          this.loading = false;
          this.changed = true;
        })
        .catch((error) => console.log(error));
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    backToTop: function () {
      $("html,body").stop().animate(
        {
          scrollTop: 0,
        },
        "fast",
        "swing"
      );
    },
  },
  created() {
    this.backToTop();
    this.loading = true;
    this.changed = false;
    this.getCashFlows();
  },
};
</script>

<style scoped>
@import url("~@/assets/admin/css/admin-loader.css");
</style>




// WEBPACK FOOTER //
// src/components/admin/CashFlowList.vue